import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import { PHYSICIAN } from '../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

/**
 * Get Handout
 * @param {Function} callback
 */
export function getHandout(callback) {
    return function (dispatch) {
        Client.get(PHYSICIAN.TUTOR_HANDOUT, null, true)
            .then((response) => {
                myLog('===card Delete response===::::', response.response_code);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_PHYSICIAN_HANDOUT,
                        payload: response.response,
                    });
                }
                callback(response);
            })
            .catch((error) => {
                myLog('====card delete error===????', error);
            });
    };
}

export function getStudentInformation(values, callback) {
    return function (dispatch) {
        Client.get(PHYSICIAN.STUDENT_INFORMATION, values, true)
            .then((response) => {
                myLog('===card Delete response===::::', response.response_code);
                if (response.response_code === 0) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_STUDENT_INFORMATION,
                        payload: response.response,
                    });
                }
                callback(response);
            })
            .catch((error) => {
                myLog('====card delete error===????', error);
            });
    };
}
